import Button, { buttonClass } from './Button';

export { buttonClass };
export default Button;
